import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('enter_the_verification__ternative_email_address'),
    codeFieldTitle: defineMessage('enter_the_verification_code'),
    wrongCodeErrorText: defineMessage('wrong_code'),
    emailCodePlaceholder: defineMessage('enter_the_verification_code_1'),
};
